import {
  KNOWN_FEATURE_FLAG_KEYS,
  STAFF_OVERRIDE_FLAGS,
  type FeatureFlagMap,
} from "encamp-shared/src/featureFlags";
import { useMemo } from "react";

import { useCurrentUser } from "./useCurrentUser";
import { useTenant } from "./useTenant";

export function useFeatureFlags(): {
  featureFlags: FeatureFlagMap;
  loading: boolean;
} {
  const { tenant, loading: tenantLoading } = useTenant();
  const { isStaff, loading: userLoading } = useCurrentUser();

  const featureFlags = useMemo(() => {
    const trueFeatureFlags = new Set(
      tenant?.tenantConfigs.filter((config) => config.value).map((config) => config.key)
    );

    if (isStaff) {
      for (const flag of STAFF_OVERRIDE_FLAGS) {
        trueFeatureFlags.add(flag);
      }
    }

    return Object.fromEntries(
      KNOWN_FEATURE_FLAG_KEYS.map((key) => [key, trueFeatureFlags.has(key)])
    ) as FeatureFlagMap;
  }, [tenant?.tenantConfigs, isStaff]);

  return { featureFlags, loading: tenantLoading || userLoading };
}
